export * from "./lib/SparqlXmlParser";
